// src/store/auth.js
// Simple reactive auth store — no Vuex/Pinia needed

import { reactive } from 'vue'

const TOKEN_KEY = 'babilonia_auth_token'
const USER_KEY = 'babilonia_auth_user'

const state = reactive({
  token: localStorage.getItem(TOKEN_KEY) || null,
  user: JSON.parse(localStorage.getItem(USER_KEY) || 'null'),
})

export const authStore = {
  state,

  get isLoggedIn() {
    return !!state.token && !!state.user
  },

  get currentUser() {
    return state.user
  },

  get token() {
    return state.token
  },

  hasPermission(permission) {
    if (!state.user) return false
    if (state.user.role === 'admin') return true
    return (state.user.permissions || []).includes(permission)
  },

  isAdmin() {
    return state.user?.role === 'admin'
  },

  login(token, user) {
    state.token = token
    state.user = user
    localStorage.setItem(TOKEN_KEY, token)
    localStorage.setItem(USER_KEY, JSON.stringify(user))
  },

  logout() {
    state.token = null
    state.user = null
    localStorage.removeItem(TOKEN_KEY)
    localStorage.removeItem(USER_KEY)
  },

  async fetchMe() {
    if (!state.token) return null
    try {
      const res = await fetch('/api/auth/me', {
        headers: { Authorization: `Bearer ${state.token}` }
      })
      if (res.ok) {
        const data = await res.json()
        state.user = data.user
        localStorage.setItem(USER_KEY, JSON.stringify(data.user))
        return data.user
      } else {
        this.logout()
        return null
      }
    } catch {
      return null
    }
  }
}

export default authStore
